[
  {
    "key": "TaxFederalIncome",
    "name": "Federal Income Tax",
    "fillingCategoryKey": "catTaxesIncomeFederal",
    "growthRate": 0.014,
    "isCalculationPerPerson": false,
    "bracketType": "Federal",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxStateIncome",
    "name": "State Income Tax",
    "fillingCategoryKey": "catTaxesIncomeState",
    "growthRate": 0.014,
    "isCalculationPerPerson": false,
    "bracketType": "State",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxMedicare",
    "name": "Medicare Tax",
    "fillingCategoryKey": "catTaxesMedicareW2Federal",
    "growthRate": 0,
    "isCalculationPerPerson": true,
    "bracketType": "Medicare",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxSocialSecurity",
    "name": "Social Security Tax",
    "fillingCategoryKey": "catTaxesSocialSecurityW2Federal",
    "growthRate": 0.014,
    "isCalculationPerPerson": true,
    "bracketType": "SocialSecurity",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxCapitalGains",
    "name": "Capital Gains Tax",
    "fillingCategoryKey": "catTaxesCapitalGains",
    "growthRate": 0.014,
    "isCalculationPerPerson": false,
    "bracketType": "CapitalGains",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxStateProperty",
    "name": "State Property Tax",
    "fillingCategoryKey": "catTaxesProperty",
    "growthRate": 0,
    "isCalculationPerPerson": false,
    "bracketType": null,
    "calculationType": "Simplified"
  },
  {
    "key": "TaxNetInvestmentIncome",
    "name": "Net Investment Income Tax",
    "fillingCategoryKey": "catTaxesNetInvestmentIncomeFederal",
    "growthRate": 0,
    "isCalculationPerPerson": false,
    "bracketType": null,
    "calculationType": "Thresholds"
  },
  {
    "key": "TaxMedicareSE",
    "name": "Self-Employment Medicare Tax",
    "fillingCategoryKey": "catTaxesMedicareEntrepreneurshipFederal",
    "growthRate": 0,
    "isCalculationPerPerson": true,
    "bracketType": "Medicare",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxSocialSecuritySE",
    "name": "Self-Employment Social Security Tax",
    "fillingCategoryKey": "catTaxesSocialSecurityEntrepreneurshipFederal",
    "growthRate": 0.014,
    "isCalculationPerPerson": true,
    "bracketType": "SocialSecurity",
    "calculationType": "Brackets"
  },
  {
    "key": "TaxAdditionalMedicare",
    "name": "Additional Medicare Tax",
    "fillingCategoryKey": "catTaxesMedicareAdditionalFederal",
    "growthRate": 0,
    "isCalculationPerPerson": false,
    "bracketType": null,
    "calculationType": "Thresholds"
  },
  {
    "key": "TaxAlternativeMinimum",
    "name": "Alternative Minimum Tax",
    "fillingCategoryKey": "catTaxesAlternativeMinimumFederal",
    "growthRate": 0,
    "isCalculationPerPerson": false,
    "bracketType": "AMT",
    "calculationType": "Brackets"
  }
]
